export default __webpack_public_path__ + "static/media/astronaut.0005e707.jpg";